import React from "react";
import { useNavigate } from "react-router-dom";
import { colors, fonts } from "../theme";
import { View, Text, Card, Press, ScreenHeader } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { SCENARIOS, t } from "../content";

export default function Scenarios() {
  const navigate = useNavigate();
  const { tr, lang } = useI18n();
  return (
    <View style={{ flex: 1, minHeight: "100vh", backgroundColor: colors.surfaceSecondary }}>
      <ScreenHeader title={tr("scenarioChallenge")} onBack={() => navigate(-1)} />
      <View style={{ padding: 20, gap: 14 }}>
        {SCENARIOS.map((sc) => (
          <Press key={sc.id} testID={`scenario-${sc.id}`} onClick={() => navigate(`/scenario/${sc.id}`)}>
            <Card style={{ padding: 0, overflow: "hidden" }}>
              <div style={{ height: 140, backgroundImage: `url(${sc.image})`, backgroundSize: "cover", backgroundPosition: "center", position: "relative" }}>
                <div style={{ position: "absolute", inset: 0, background: "linear-gradient(rgba(15,37,64,0.1), rgba(15,37,64,0.7))" }} />
              </div>
              <View style={{ padding: 16 }}>
                <View row style={{ alignItems: "center", gap: 8, marginBottom: 6 }}>
                  <Icon name="compass" size={20} color={colors.brandPrimary} weight="fill" />
                  <Text style={{ fontWeight: fonts.bold, fontSize: 17, color: colors.onSurface }}>{t(sc.title, lang)}</Text>
                </View>
                <Text style={{ fontWeight: fonts.regular, fontSize: 13, lineHeight: "20px", color: colors.muted }}>{t(sc.intro, lang)}</Text>
                <View row style={{ alignItems: "center", gap: 6, marginTop: 12 }}>
                  <Text style={{ fontWeight: fonts.semibold, fontSize: 13, color: colors.brandPrimary }}>{sc.steps.length} {lang === "de" ? "Entscheidungen" : "decisions"}</Text>
                  <Icon name="arrow-right" size={16} color={colors.brandPrimary} weight="bold" />
                </View>
              </View>
            </Card>
          </Press>
        ))}
      </View>
    </View>
  );
}
